import { render } from "./PickupBoxes.vue?vue&type=template&id=79cc4f7e&scoped=true&ts=true"
import script from "./PickupBoxes.vue?vue&type=script&lang=ts"
export * from "./PickupBoxes.vue?vue&type=script&lang=ts"

import "./PickupBoxes.vue?vue&type=style&index=0&id=79cc4f7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cc4f7e"]])

export default __exports__